import { render, staticRenderFns } from "./CircularMenu.vue?vue&type=template&id=652a8bd0&"
import script from "./CircularMenu.ts?vue&type=script&lang=js&"
export * from "./CircularMenu.ts?vue&type=script&lang=js&"
import style0 from "./CircularMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports